<div class="checkbox-wrapper">
  <input
    [id]="id"
    type="checkbox"
    [disabled]="disabled"
    [(ngModel)]="value"
    (ngModelChange)="onChange()"
  />
  <label class="checkbox-label" [for]="id">
    <span class="checkbox-tick"></span>
    <span class="checkbox-text">{{ label }}</span>
  </label>
</div>
